import React, { ReactNode, useState, useId, HTMLAttributes } from "react";
import { observer } from "mobx-react";
import styles from "./ExpandableText.scss";
import classNames from "classnames";

interface IExpandableTextProps extends HTMLAttributes<HTMLDivElement> {
  header: string;
  children: ReactNode;
  expanded?: boolean;
  extra?: React.ReactNode;
}

export const ExpandableText = observer(
  ({ header, children, expanded = false, extra, id, ...rest }: IExpandableTextProps) => {
    const [open, setOpen] = useState(expanded);
    const contentId = useId();

    return (
      <div className={classNames({ [styles.open]: open })} {...rest}>
        <button
          className={styles.header}
          onClick={() => setOpen(!open)}
          aria-expanded={open}
          aria-controls={contentId}
          id={id}
        >
          {header}
        </button>
        <div id={contentId} className={styles.body}>
          <div className={styles.content}>{children}</div>
          {extra && <div className={styles.extra}>{extra}</div>}
        </div>
      </div>
    );
  }
);
